import Grid from '@mui/system/Unstable_Grid/Grid';
import { InlineQuillEdit } from '../../../components/InlineQuillEdit';
import { InlineTextEdit } from '../../../components/InlineTextEdit';
import ItemIcon from './ItemIcon';
import React from 'react';
import { TimelineAsset } from 'content/models/LessonComponentContent';
import Typography from '@mui/material/Typography';
import { cloneDeep } from 'lodash';
import styles from '../../../styles/Timeline.module.scss';

interface TimelineEditorProps {
  componentkey: number;
  timelineItem: TimelineAsset;
  handleChange: (item: TimelineAsset) => void;
}
export default function TimelineEditor(props: TimelineEditorProps) {
  const { componentkey, timelineItem } = props;

  const handleChange = (key: keyof typeof timelineItem, value: string) => {
    const copy = cloneDeep(timelineItem);
    props.handleChange({ ...copy, [key]: value });
  };

  return (
    <Grid container direction="column" sx={{ padding: '8px' }}>
      <Grid container sx={{ width: '100%' }} spacing={1}>
        <Grid container direction="column" xs={12} sm={6}>
          <Grid>
            <Typography className={styles.typographyFont}>
              Date and Time
            </Typography>
          </Grid>
          <Grid>
            <InlineQuillEdit
              placeholder="Add item time and/or date"
              value={timelineItem.dateAndTime || ''}
              componentKey={componentkey}
              styleType="label"
              onChange={(value: string) => handleChange('dateAndTime', value)}
            />
          </Grid>
        </Grid>
        <Grid container xs={12} sm={6} direction="column">
          <Grid container justifyContent="space-between">
            <Grid>
              <Typography className={styles.typographyFont}>
                Item color
              </Typography>
            </Grid>
            <Grid>
              <Typography className={styles.typographyFont}>
                Border color
              </Typography>
            </Grid>
            <Grid>
              <Typography className={styles.typographyFont}>
                Item icon
              </Typography>
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between" sx={{ pt: '0px' }}>
            <Grid>
              <ItemIcon
                color={timelineItem.itemColor}
                disabled={!timelineItem.itemColor}
                resetButton
                onChange={(value: string) => handleChange('itemColor', value)}
              />
            </Grid>
            <Grid>
              <ItemIcon
                color={timelineItem.itemBorder}
                disabled={!timelineItem.itemBorder}
                resetButton
                onChange={(value: string) => handleChange('itemBorder', value)}
              />
            </Grid>
            <Grid>
              <ItemIcon
                assetkey={timelineItem.itemIcon}
                disabled={!timelineItem.itemIcon}
                resetButton
                icon
                onChange={(value: string) => handleChange('itemIcon', value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <hr />
      </Grid>
      <Grid>
        <Typography className={styles.typographyFont}>Heading</Typography>
      </Grid>
      <Grid>
        <InlineQuillEdit
          placeholder="Add item heading text"
          value={timelineItem.heading || ''}
          componentKey={componentkey}
          styleType="noAlignList"
          onChange={(value: string) => handleChange('heading', value)}
        />
      </Grid>
      <Grid>
        <hr />
      </Grid>
      <Grid>
        <Typography className={styles.typographyFont}>Paragraph</Typography>
      </Grid>
      <Grid>
        <InlineQuillEdit
          placeholder="Add item paragraph text"
          value={timelineItem.paragraph || ''}
          componentKey={componentkey}
          styleType="noAlignList"
          onChange={(value: string) => handleChange('paragraph', value)}
        />
      </Grid>
    </Grid>
  );
}
